import { Suspense } from "react"
import { useController, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CountrySelectorFormSchema } from "@/models/patient"
import { CountrySearch } from "@/modules/common/address-section/country-search"

const fields = ["country", "postalCode", "city", "houseNumberStreet"] as const

interface CountrySelectorProps {
  onCountryChange?: (country: string) => void
}

const CountrySelector = ({ onCountryChange }: CountrySelectorProps) => {
  const { t } = useTranslation()
  const form = useFormContext<CountrySelectorFormSchema>()

  const {
    setValue,
    control,
    formState: { errors: formErrors },
  } = form

  const { field: country } = useController({ name: "country", control })

  const setFieldsValue = (fieldName?: (typeof fields)[number], value?: string) => {
    fields.forEach((field) => {
      const fieldValue = fieldName && value && fieldName === field ? value : ""
      setValue(field, fieldValue, { shouldValidate: true, shouldDirty: true })
    })
  }

  return (
    <Suspense
      fallback={<CountrySearch placeholder={`${t("common.country")}*`} value={country.value} onSelect={() => ""} />}>
      <CountrySearch
        placeholder={`${t("common.country")}*`}
        value={country.value ?? ""}
        onSelect={({ country: countryValue }) => {
          if (countryValue && countryValue !== country.value) {
            setFieldsValue("country", countryValue)
            onCountryChange?.(countryValue)
          }
        }}
        error={t(formErrors?.country?.message || "")}
        onClear={setFieldsValue}
      />
    </Suspense>
  )
}

export { CountrySelector }
